<template>
  <div :class="`response response--${typeError}`">
    <p v-html="message" class="response-text" />
  </div>
</template>

<script>
export default {
  props: {
    response: {
      type: Object,
      default: () => {
        return {}
      }
    },
    message: {
      type: String,
      default: ''
    }
  },
  computed: {
    typeError() {
      if (this.response.status >= 200 && this.response.status < 300) {
        return 'success';
      }

      if (this.response.status >= 400 && this.response.status < 500) {
        return 'warning';
      }

      return 'error';
    },
  }
}
</script>

<style lang="scss" scoped>
  .response {
    @include margin(30px auto null);
    max-width: 550px;
    align-self: center;

    .is-magic & {
      @include padding(var(--symplicy-spacing-v) var(--symplicy-spacing-h));
      display: flex;
      align-items: center;
      margin-top: 0;
      background-color: color('background');
      border-radius: 10px;
      max-width: 780px;
      // height: calc(100% - 272px);
      flex-grow: 1;
    }

    .response-text {
      color: color('text');
      font-size: rem(22px);
      line-height: 1.4;
      text-align: center;
    }

    &--success {
      .response-text {
        color: color('success');
      }
    }

    &--warning,
    &--error {
      @include margin(0 auto 30px);

      .response-text {
        color: color('error');
      }
    }
  }
</style>

<style lang="scss">
  .response {
    .response-text {
      a {
        color: currentColor;
      }
    }
  }
</style>
